import {useRouterHistory} from 'react-router';
import {createHashHistory} from 'history';

// eslint-disable-next-line react-hooks/rules-of-hooks
const LocalHistory = useRouterHistory(createHashHistory)({queryKey: false});

export default LocalHistory;
